import pixelDb from "@/pixels/pixelDb";
import * as MUTATIONS from "@/config/constants/mutation-types";

describe("pixelDb", () => {
  it("should have correct triggers", () => {
    expect(pixelDb.triggers).toHaveProperty(MUTATIONS.ON_ROUTE);
    expect(pixelDb.triggers).toHaveProperty(MUTATIONS.ADOBE_APP_STARTED);
    expect(pixelDb.triggers).toHaveProperty(MUTATIONS.ADOBE_APP_ON_CLICK_START);
  });

  it("should have correct providers", () => {
    expect(pixelDb.providers).toHaveProperty("Adobe");
    expect(pixelDb.providers).toHaveProperty("Facebook");
    expect(pixelDb.providers).toHaveProperty("GoogleRMKT");
    expect(pixelDb.providers).toHaveProperty("GoogleSiteTag");
  });

  it("should have correct triggers for ON_ROUTE", () => {
    const onRouteTriggers = pixelDb.triggers[MUTATIONS.ON_ROUTE];
    expect(onRouteTriggers).toHaveProperty("landing");
    expect(onRouteTriggers).toHaveProperty("paso1");
    expect(onRouteTriggers).toHaveProperty("paso2");
    expect(onRouteTriggers).toHaveProperty("paso3");
    expect(onRouteTriggers).toHaveProperty("paso4");
    expect(onRouteTriggers).toHaveProperty("gracias");
    expect(onRouteTriggers).toHaveProperty("mensaje");
  });

  it("should have correct triggers for ADOBE_APP_STARTED", () => {
    const adobeAppStartedTriggers =
      pixelDb.triggers[MUTATIONS.ADOBE_APP_STARTED];
    expect(adobeAppStartedTriggers).toEqual(["Adobe.appStartedClick"]);
  });

  it("should have correct triggers for ADOBE_APP_ON_CLICK_START", () => {
    const adobeAppOnClickStartTriggers =
      pixelDb.triggers[MUTATIONS.ADOBE_APP_ON_CLICK_START];
    expect(adobeAppOnClickStartTriggers).toEqual(["Adobe.appOnClickStart"]);
  });
});
